var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"center"},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":96,"width":96},on:{"animCreated":_vm.handleAnimation}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }